import { useEffect, useRef } from "react";
import {
  usePaymentStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";
import CourtBooking from "./CourtBooking";
import CourtBookingOld from "./CourtBookingOld";

export const CourtBookingScreen = () => {
  const isFullBooking = process.env.REACT_APP_IS_FULL_BOOKING;
  const paymentStore = usePaymentStore();
  const selectCircleStore = useSelectCircleStore();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      paymentStore.fetchExternalWalletBalance();
      selectCircleStore.fetchPlayers();
      paymentStore.fetchAllCards();
      paymentStore.fetchExternalWalletBalance();
      hasFetched.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isFullBooking === "true" ? <CourtBookingOld /> : <CourtBooking />;
};
